jQuery(document).ready(function(){
    let btnMenu = jQuery('#btnMenu');

    const mySwiperHeroHome = new Swiper('.mySwiperHeroHome', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    const swiperProductsPage = new Swiper('.swiperProductsPage', {
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 15,
        loop:true,
        navigation: {
            nextEl: '.swiper-button-next-pages',
            prevEl: '.swiper-button-prev-pages',
        },
        breakpoints:{
            768:{
                slidesPerView: 5,
                spaceBetween: 15,
                loop:true,
            },
        }
    });

    const swiperGalleryProduct = new Swiper('.swiperGalleryProduct', {
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next-pages',
            prevEl: '.swiper-button-prev-pages',
        },
        breakpoints:{
            768:{
                slidesPerView: 5,
            },
        }
    });

    // Effect Nav
    const scrollNav = () => {
        document.addEventListener('scroll', () => {

            // Header
            const header = document.querySelector('.header');
        
            if (window.scrollY > 100) {
                header.classList.add('scroll');
            } else {
                header.classList.remove('scroll');
            }
        
        });
    };

    // EVENTOS
    jQuery(btnMenu).on('click', function(e) {
        e.preventDefault();

        jQuery('.header__container--nav').toggleClass('active');
        jQuery('.header').toggleClass('open');
    });

    new ModalVideo(".js-modal-btn");
    scrollNav();
    AOS.init({
        duration: 1200,
    });
});